import React from 'react';
export function Footer() {
  return <footer className="py-16 px-4 border-t border-beige bg-cream" data-id="element-15">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center space-y-6" data-id="element-16">
        <div className="space-y-2" data-id="element-17">
          <h2 className="text-3xl font-bold text-text-dark tracking-wide" data-id="element-18">
            Portal <span className="italic text-[#4A3B6B]" data-id="element-19">Terapéutico</span>
          </h2>
          <p className="text-text-muted text-lg font-light" data-id="element-20">
            Material digital terapéutico y educativo.
          </p>
        </div>

        <div className="w-16 h-px bg-gold/40" data-id="element-21" />

        <div className="text-text-muted/60 text-sm" data-id="element-22">
          &copy; {new Date().getFullYear()} Portal Terapéutico. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}